import { motion, AnimatePresence } from "framer-motion";
import { useThemeColors } from "../context/ThemeColorContext";
import { ThemeContext } from "../context/ThemeContext";
import { useContext, useEffect } from "react";
import { useStaticTexts } from "../context/StaticTextContext";
import {
  CheckCircle,
  XCircle,
  AlertTriangle,
  Info,
} from "lucide-react";

const iconMap = {
  success: <CheckCircle className="w-6 h-6 text-green-600" />,
  error: <XCircle className="w-6 h-6 text-red-500" />,
  warning: <AlertTriangle className="w-6 h-6 text-yellow-500" />,
  info: <Info className="w-6 h-6 text-blue-500" />,
};

const PopupMessage = ({
  message,
  type = "success", // success, error, warning, info
  onClose,
}) => {
  const { darkMode } = useContext(ThemeContext);
  const {
    lightSecondary,
    darkText,
    darkPrimary,
    darkAccent,
  } = useThemeColors();

  const staticTexts = useStaticTexts();
  const closeText = staticTexts?.popup_close_text || "بستن";

  const isError = type === "error";

  const backgroundColor =  lightSecondary;
  const textColor = darkMode ? darkText : "#111";

  useEffect(() => {
    if (!message) return;
    const timer = setTimeout(() => {
      onClose();
    }, 10000); // حذف خودکار بعد از ۱۰ ثانیه
    return () => clearTimeout(timer);
  }, [message, onClose]);

  return (
    <AnimatePresence>
      {message && (
        <motion.div
          className="fixed inset-0 z-50 flex items-center justify-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          {/* تار کردن پس‌زمینه */}
          <div className="absolute inset-0 bg-black bg-opacity-40 backdrop-blur-sm"></div>

          {/* کارت پیام */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            transition={{ duration: 0.3 }}
            className="relative z-50 rounded-xl px-6 py-5 max-w-md w-full mx-4 shadow-2xl"
            style={{
              backgroundColor,
              color: textColor,
              border: `1px solid ${darkMode ? darkAccent : "#ccc"}`,
            }}
          >
            <div className="flex items-center gap-3 mb-4 justify-center">
              {iconMap[type]}
              <p
                className={`text-base font-medium text-center ${
                  isError
                    ? "text-red-500"
                    : type === "warning"
                    ? "text-yellow-600"
                    : type === "info"
                    ? "text-blue-500"
                    : "text-green-600"
                }`}
              >
                {message}
              </p>
            </div>

            <div className="flex justify-center">
              <button
                onClick={onClose}
                className="px-5 py-2 rounded-lg font-medium transition border"
                style={{
                  backgroundColor: darkMode ? "#fff" : darkAccent,
                  color: darkMode ? darkPrimary : "#fff",
                  borderColor: darkMode ? darkPrimary : "transparent",
                }}
              >
                {closeText}
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PopupMessage;
